import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
import { getBrighterColor } from "../../utils/functions";
export var StyledBadgeSpan = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  padding: ", ";\n  justify-content: center;\n  align-items: flex-start;\n  gap: 10px;\n  border-radius: ", ";\n  background: ", ";\n\n  color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px; /* 142.857% */\n  letter-spacing: 0.1px;\n"], ["\n  display: flex;\n  padding: ", ";\n  justify-content: center;\n  align-items: flex-start;\n  gap: 10px;\n  border-radius: ", ";\n  background: ", ";\n\n  color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px; /* 142.857% */\n  letter-spacing: 0.1px;\n"])), function (_a) {
    var theme = _a.theme;
    return "".concat(theme.spacing.xxs, " ").concat(theme.spacing.s);
}, function (_a) {
    var theme = _a.theme;
    return theme.radius.m;
}, function (_a) {
    var theme = _a.theme, $customColor = _a.$customColor;
    return getBrighterColor(theme.colors[$customColor].lightest, 60);
}, function (_a) {
    var theme = _a.theme, $customColor = _a.$customColor;
    return theme.colors[$customColor].default;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map